var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { css } from '@corti/style';
import { useTheme } from '@corti/theme';
import { Base } from 'lib/cortiUI';
export function ContainerSection(props) {
    const { children, showTopSeparator = false, showBottomSeparator = false } = props, rest = __rest(props, ["children", "showTopSeparator", "showBottomSeparator"]);
    const theme = useTheme();
    function getCss() {
        const res = [];
        if (showTopSeparator) {
            res.push(`inset 0 1px 0px 0px ${theme.palette.background.divider}`);
        }
        if (showBottomSeparator) {
            res.push(`inset 0 -1px 0px 0px ${theme.palette.background.divider}`);
        }
        return res.join(', ');
    }
    return (React.createElement(Base, Object.assign({ width: "100%", py: 6, px: 7, className: css({
            boxShadow: getCss(),
        }) }, rest), children));
}
